import { Icon, Text } from "@smartsuite/react-ui/lib";
import { RefreshFooterContainer, RefreshButton } from "./style";
import { GrayColors } from "@smartsuite/types";
import { useRootStore } from "../../../../../../../stores/hooks";
import type { ActionCandidate } from "../../../../../../../types/candidate";
import { t } from "i18next";

export const RefreshFooter: React.FC<{
  handleClose: () => void;
  action?: ActionCandidate;
}> = ({ handleClose, action }) => {
  const store = useRootStore();
  const candidate = store.automations.candidate;

  const handleRefresh = (): void => {
    if (action) {
      store.automations.setRefreshingList(true);
      candidate.setNeedToUpdateDynamicDescription(action, true);
      handleClose();
    }
  };

  return (
    <RefreshFooterContainer>
      <RefreshButton onClick={handleRefresh}>
        <Icon name="thin-refresh" size="S" color={GrayColors["G-8"]} />
        <Text size="xs" weight="medium" color="tertiary">
          {t("general.refresh-list")}
        </Text>
      </RefreshButton>
    </RefreshFooterContainer>
  );
};
